import { Form } from "../Model/Form";
import { Section } from "../Model/Section";
import { Question } from "../Model/Question";
import { AnswerEmpty } from "../Model/AnswerEmpty";
export class FormsService {
    constructor(apiService, queryParamsFactory, answersService) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
        this.answersService = answersService;
    }
    async queryForms(query) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        if (hasNetwork) {
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`forms?${params}`);
            if (!response.ok) {
                throw new Error('Ha ocurrido un error al realizar la consulta de formularios.');
            }
            const content = await response.json();
            const dataString = JSON.stringify({
                results: content.results.map(data => this.createForm(data)),
                numResults: content.numResults
            });
            for (const result of content.results) {
                const dataString = JSON.stringify(result);
                localStorage.setItem(`${result.id}`, dataString);
                this.answersService.getInstanceAnsers(result.id.toString());
                // if (localStorage.getItem(`${result.id}`) && localStorage.getItem(`answer-${result.id}`)) {
                //     console.log(`Cache de ${result.name} correcto`); 
                // }
            }
            localStorage.setItem(`formsQuerys`, dataString);
            return {
                results: content.results.map(data => this.createForm(data)),
                numResults: content.numResults
            };
        }
        const forms = JSON.parse(localStorage.getItem(`formsQuerys`));
        if (!forms || forms.length === 0) {
            throw new Error('Ha ocurrido un error al obtener la lista de formularios.');
        }
        return forms;
    }
    async getForms(offset = 0, limit = 10) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        if (hasNetwork) {
            const response = await this.apiService.get(`forms/${offset}/${limit}`);
            if (!response.ok) {
                throw new Error('Ha ocurrido un error al obtener la lista de formularios.');
            }
            const content = await response.json();
            const dataString = JSON.stringify(content);
            localStorage.setItem(`formsInstances`, dataString);
            return content.map(data => this.createForm(data));
        }
        const forms = JSON.parse(localStorage.getItem(`formsInstances`));
        if (!forms || forms.length === 0) {
            throw new Error('Ha ocurrido un error al obtener la lista de formularios.');
        }
        console.log('Cache INSTANCES');
        return forms.map(data => this.createForm(data));
    }
    async getForm(formId) {
        const hasNetwork = localStorage.getItem('hasNetwork') === 'true' ? true : false;
        if (hasNetwork) {
            const response = await this.apiService.get(`form/${formId}`);
            if (!response.ok) {
                throw new Error('Ha ocurrido un error al obtener la lista de formularios.');
            }
            const content = await response.json();
            const dataString = JSON.stringify(content);
            localStorage.setItem(`${content.id}`, dataString);
            return this.createForm(content);
        }
        const form = JSON.parse(localStorage.getItem(`${formId}`));
        if (!form) {
            throw new Error('Ha ocurrido un error al obtener la lista de formularios.');
        }
        return this.createForm(form);
    }
    createLocalStorageForm(form) {
        return this.createForm(form);
    }
    createForm(data) {
        return new Form(data.id, data.name, data.description, data.bodyPartner, data.status, data.disabled, data.production, data.sections.map(data => this.createSection(data)), data.answers ? data.answers.map(data => this.createAnswerEmpty(data)) : []);
    }
    createSection(data) {
        return new Section(data.id, data.name, data.status, data.description, data.position, data.width, data.required, data.questions.map(data => this.createQuestion(data)));
    }
    createAnswerEmpty(data) {
        return new AnswerEmpty(data.id, data.instanceId, data.questionId, data.value);
    }
    createQuestion(data) {
        const { type, options } = data;
        //Nos aseguramos que el objeto de opciones tiene las
        //propiedades necesarias para el tipo de pregunta
        if (['bool', 'multiple'].includes(type)) {
            //Creamos el array de opciones de pregunta si es necesario
            if (!options.questionOptions) {
                options.questionOptions = [];
            }
        }
        else if ('grid' === type) {
            //Creamos el objteo de rejilla de pregunta si es necesario
            if (!options.questionGrid) {
                options.questionGrid = {
                    columns: [],
                    rows: []
                };
            }
        }
        return new Question(data.id, data.name, data.description, data.status, data.position, data.width, data.forced, data.options, data.type, data.sections.map(data => this.createSection(data)));
    }
}
